import { takeLatest } from "redux-saga/effects";
import { getEntitySaga } from "./apiSagas.js";

import { INVOICES } from "../actions/actionConstants.js";

// -- WATCHERS -- //

export function* watchInvoiceSagas() {
  yield takeLatest(INVOICES.GET, getEntitySaga, INVOICES, undefined);
}
